import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Auth0Wrapper } from '../services/auth0/Auth0Wrapper';
import Global from '../store/global-selectors';

export const useIsAccountOwner = () => {
  const [isOwner, setIsOwner] = useState(false);
  const isAccountOwnerFromRedux = useSelector(Global.selectUserIsAccountOwner);

  useEffect(() => {
    if (Auth0Wrapper.isUsingAuth0Auth()) {
      Auth0Wrapper.getIdTokenClaims()
        .then((claims) => {
          if (claims) {
            setIsOwner(claims[Auth0Wrapper.CLAIMS.IS_ACCOUNT_OWNER] === 'true');
            return;
          }
          setIsOwner(false);
        })
        .catch(() => {
          setIsOwner(false);
        });
      return;
    }
    // always prefer reading the claim on the jwt for security, but if we were on native auth we need to
    // fallback to the value provided during app initialization
    setIsOwner(isAccountOwnerFromRedux ?? false);
  }, [isAccountOwnerFromRedux]);

  return isOwner;
};
